<template>
  <div class="row roomy align-stretch margin-top-md margin-bottom-2xl">
    <div
      class="column-12 laptop:column-4"
      style="height: 100%"
    >
      <a
        href="https://fontawesome.com/leaderboard/new#request"
        class="card blue"
        @click="$posthog.capture('icon_requests_leaderboard_link_click')"
      >
        <div class="header">
          <i
            v-if="version !== 5"
            class="fas fa-message-question fa-fw fa-4x"
          />
          <i
            v-else
            class="fas fa-question-circle fa-fw fa-4x"
          />
        </div>
        <div class="section">
          <h2 class="h4">Request an Icon</h2>
          <p>
            Suggest an icon idea to our community on the
            <site-link
              :to="{ name: 'leaderboard.new' }"
              @click.native="$posthog.capture('icon_requests_leaderboard_link_click')"
              >Icon Requests Leaderboard</site-link
            >.
          </p>
        </div>
      </a>
    </div>

    <div
      class="column-12 laptop:column-4"
      style="height: 100%"
    >
      <site-link
        :to="$docs('/web/add-icons/upload-icons')"
        class="card teal"
        @click.native="$posthog.capture('docs_upload_icons_link_click')"
      >
        <div class="header">
          <i
            v-if="version !== 5"
            class="fas fa-cloud-arrow-up fa-fw fa-4x"
          />
          <i
            v-else
            class="fas fa-cloud-upload-alt fa-fw fa-4x"
          />
        </div>
        <div class="section">
          <h2 class="h4">Upload an Icon</h2>
          <p>Upload your own icon to a Kit and easily use it just like it an official Font Awesome icon!</p>
        </div>
      </site-link>
    </div>

    <div
      class="column-12 laptop:column-4"
      style="height: 100%"
    >
      <site-link
        :to="$docs('/web/add-icons/icon-wizard')"
        class="card yellow"
        @click.native="$posthog.capture('icons_wizard_link_click')"
      >
        <div class="header">
          <font-awesome-icon
            :icon="$v6.solid.faSquareDashedCirclePlus"
            fixed-width
            size="4x"
          />
        </div>
        <div class="section">
          <h2 class="h4">Use the Icon Wizard</h2>
          <p>You can magically add a modifier to any icon with our Icon Wizard. Give it a try!</p>
        </div>
      </site-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'IconSupplementalActions',

    props: {
      layoutWide: {
        type: Boolean,
        default: false
      },
      version: {
        type: Number
      }
    }
  }
</script>
